'use strict';
const angular = require('angular');

/*@ngInject*/
export function DynamicPageService($resource) {
  return $resource('/api/pages/:id', {
    id: '@_id'
  },{
    queryByType: {
      method: 'GET',
      url: "/api/pages/type/:type",
      isArray: true
    },
    getByName: {
      method: 'GET',
      url: "/api/pages/name/:name"
    },
    getPublicByName: {
      method: 'GET',
      url: "/api/pages/public/name/:name"
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.ap.services.DynamicPageService', [])
  .factory('DynamicPageService', DynamicPageService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/dynamic-page/dynamic-page.service.js